"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductMediaCollage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const react_1 = require("react");
const cotopaxi_1 = require("@as/cotopaxi");
const andes_react_1 = require("@yonderland/andes-react");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const react_i18next_1 = require("react-i18next");
const ProductMediaCollageItem_1 = require("./ProductMediaCollageItem");
const ProductPreviewLightBox_1 = require("../product-preview/product-preview-light-box/ProductPreviewLightBox");
const common_components_1 = require("@as-react/common-components");
const useProductMedia_1 = require("./useProductMedia");
const SHOWN_COLLAGE_ITEMS = 4;
const COLLAGE_TEST_ID = 'product_collage';
const ProductMediaCollage = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const { isShopLanding } = (0, common_components_1.useAemConfig)();
    const { mediaCollection, alt } = (0, useProductMedia_1.useProductMedia)();
    const selectedColorId = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedColorId)());
    const selectedSku = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSelectedSku)());
    const { productCode, productId } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)());
    const popoverHandlers = (0, cotopaxi_1.usePopoverHandlers)();
    const { isSm, isMd } = (0, andes_react_1.useBreakpoints)();
    const [activeSlideIndex, setActiveSlideIndex] = (0, react_1.useState)(0);
    const [showAllMedia, setShowAllMedia] = (0, react_1.useState)(false);
    const isClient = (0, andes_react_1.useIsClient)();
    (0, react_1.useEffect)(() => {
        setActiveSlideIndex(0);
    }, [selectedColorId]);
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    const handleClickCollageItem = (event, index) => {
        setActiveSlideIndex(index);
        popoverHandlers.handlePopoverOpen(event);
    };
    const productCollageItemProps = {
        wishListProduct,
        onClick: handleClickCollageItem,
    };
    const [shownMediaCollection, hiddenMediaCollection] = [
        mediaCollection.slice(0, SHOWN_COLLAGE_ITEMS),
        mediaCollection.slice(SHOWN_COLLAGE_ITEMS),
    ];
    const handleClickShowAll = () => {
        setShowAllMedia(true);
    };
    const onActiveSlideIndexChange = (newActiveSlideIndex) => {
        setActiveSlideIndex(newActiveSlideIndex);
    };
    return shownMediaCollection.length > 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.Box, { paddingBlockEnd: "4", position: { md: 'sticky' }, top: { md: '2' }, children: shownMediaCollection.length === 1 ? ((0, jsx_runtime_1.jsx)(andes_react_1.Grid, { testId: COLLAGE_TEST_ID, columns: {
                        xs: 2,
                        lg: 4,
                    }, gap: 2, children: (0, jsx_runtime_1.jsx)(andes_react_1.Grid.Cell, { span: 2, offset: { lg: 2 }, children: (0, jsx_runtime_1.jsx)(ProductMediaCollageItem_1.ProductMediaCollageItem, Object.assign({ index: 0, item: shownMediaCollection[0], showLabels: true, showWishlistButton: !isShopLanding }, productCollageItemProps)) }) })) : ((0, jsx_runtime_1.jsxs)(andes_react_1.Grid, { testId: COLLAGE_TEST_ID, columns: {
                        xs: 1,
                        lg: 2,
                    }, gap: 2, children: [shownMediaCollection.map((item, index) => ((0, jsx_runtime_1.jsx)(ProductMediaCollageItem_1.ProductMediaCollageItem, Object.assign({ index: index, item: item, showLabels: index === 0, showWishlistButton: !isShopLanding && isClient && index === (isSm || isMd ? 0 : 1) }, productCollageItemProps), index))), hiddenMediaCollection.length > 0 &&
                            (!showAllMedia ? ((0, jsx_runtime_1.jsx)(andes_react_1.Grid.Cell, { span: { lg: 2 }, children: (0, jsx_runtime_1.jsx)(andes_react_1.Box, { paddingBlockStart: "3", children: (0, jsx_runtime_1.jsx)(andes_react_1.StackInline, { contentAlign: "center", children: (0, jsx_runtime_1.jsx)(andes_react_1.ButtonAlpha, { testId: "product_collage_show_more", theme: "branded", variant: "secondary", size: "md", text: t('pdp.collage.show.more'), onClick: handleClickShowAll }) }) }) })) : (hiddenMediaCollection.map((item, index) => ((0, jsx_runtime_1.jsx)(ProductMediaCollageItem_1.ProductMediaCollageItem, Object.assign({ index: shownMediaCollection.length + index, item: item }, productCollageItemProps), index)))))] })) }), (0, jsx_runtime_1.jsx)(ProductPreviewLightBox_1.ProductPreviewLightBox, { activeSlideIndex: activeSlideIndex, alt: alt, mediaCollection: mediaCollection, onActiveSlideIndexChange: onActiveSlideIndexChange, popoverHandlers: popoverHandlers })] })) : null;
};
exports.ProductMediaCollage = ProductMediaCollage;
